function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, String, error, facetedResults, hasSearched, isResultsLoading, menuItems, searchText, selectedType) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("mp-drawer", {
        "attrs": {
          open: $attr('open')
        },
        "on": {
          close: $helpers.handleClose
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-omnisearch-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
              "attrs": {
                icon: `search`,
                value: searchText,
                placeholder: $helpers.getPlaceholderText(),
              },
              "hook": {
                insert: $helpers.handleInputInsert,
              },
              "on": {
                input: ev => $helpers.handleSearchTextChange(ev.target.value)
              },
              "class": {
                'input': true
              },
            }));
            __jade_nodes = __jade_nodes.concat((searchText) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
                "attrs": {
                  theme: `lite`,
                  selected: selectedType,
                  options: JSON.stringify($helpers.getToggleOptions()),
                },
                "on": {
                  select: $helpers.handleResultTypeSelect
                },
                "class": {
                  'filter-bar': true
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((!hasSearched || searchText === ``) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'nux': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'nux-welcome': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Start typing to search your " + ($attr('workspace-id') ? `workspace` : `project`) + "");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": Object.assign({}, {
                'is-empty': !isResultsLoading && menuItems.length === 0
              }, {
                'results': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((error) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'error': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("There were problems getting search results.");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : (!isResultsLoading && menuItems.length === 0) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'no-results': true
                  },
                }, [__vjadeSafeCode($helpers.getResultsItemsEmptyMessage())]));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'no-results-subtext': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Try again with a different term");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'no-results-feedback': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Feedback:");
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": {
                      icon: 'email'
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat(h("a", {
                    "attrs": {
                      href: "mailto:search@mixpanel.com"
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("search@mixpanel.com");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : (facetedResults || isResultsLoading) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                  "attrs": {
                    'empty-message': $helpers.getResultsItemsEmptyMessage(),
                    sections: JSON.stringify([$helpers.getItems()]),
                  },
                  "on": {
                    clickItem: $helpers.handleItemClick,
                  },
                  "hook": {
                    insert: ({
                      elm
                    }) => elm.keydownProxyEl = $component.searchInput
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!hasSearched || menuItems.length > 0) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Feedback:");
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": {
                  href: "mailto:search@mixpanel.com"
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("search@mixpanel.com");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "error" in locals ? locals.error : typeof error !== "undefined" ? error : undefined, "facetedResults" in locals ? locals.facetedResults : typeof facetedResults !== "undefined" ? facetedResults : undefined, "hasSearched" in locals ? locals.hasSearched : typeof hasSearched !== "undefined" ? hasSearched : undefined, "isResultsLoading" in locals ? locals.isResultsLoading : typeof isResultsLoading !== "undefined" ? isResultsLoading : undefined, "menuItems" in locals ? locals.menuItems : typeof menuItems !== "undefined" ? menuItems : undefined, "searchText" in locals ? locals.searchText : typeof searchText !== "undefined" ? searchText : undefined, "selectedType" in locals ? locals.selectedType : typeof selectedType !== "undefined" ? selectedType : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;